import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin", { replace: true });
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputCls = "w-full bg-transparent border-b ee-hairline focus:border-[#D4AF37] outline-none py-3 text-[#FAFAF9] transition-colors placeholder:text-[#57534E]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0C0A09] px-6 ee-grain">
      <Seo title="Admin" />
      <div className="w-full max-w-md border ee-hairline bg-[#1C1917] p-10">
        <div className="text-center mb-10">
          <Lock className="ee-gold-text mx-auto mb-4" strokeWidth={1} size={28} />
          <h1 className="font-display text-3xl tracking-[0.16em]">EQUINE EVOLVE</h1>
          <p className="ee-overline mt-2">Admin Console</p>
        </div>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-email" />
          <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-password" />
          {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
          <button disabled={loading} data-testid="admin-login-btn" className="w-full bg-[#D4AF37] text-[#0C0A09] py-4 uppercase tracking-[0.15em] text-sm hover:bg-[#B5952F] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
